export const formatPhoneNumber = (data) => {
  if (!data) return '';
  const digits = data.toString().replace(/\D/g, '');
  const match = digits.match(/^([1])?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `1 (${match[2]}) ${match[3]}-${match[4]}`;
  }
  return digits;
};
